import { AMC_DEVICE_PAGE_URL, LOGIN_URL, SCA_COOKIE } from '@/configs/constants';
import is from '@/utils/is';
import axios, { AxiosError } from 'axios';
import { fetchSession } from '../fetchSession';
import Cookies from '@/utils/cookie';
import { CLIENT_COOKIE, SESSION_COOKIE } from '@/configs/serviceConstants';
import isAuthenticatedRoute from '@/utils/isAuthenticatedRoute';
import { LOGIN_REDIRECT_TO_QUERY } from '@/constants/app';
import { deleteLogoutTokens } from '@/utils/deleteLogoutTokens';
import { ScaBridge } from '@/utils';
const axiosInstance = axios.create({
  withCredentials: true,
});

axiosInstance.interceptors.request.use(async (config) => {
  config.headers['client'] = 'web';
  return config;
});
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error: AxiosError) => {
    // redirect to login page on client side
    if (is.client() && error?.response?.status === 401) {
      deleteLogoutTokens();

      // isSCAClient
      if (Cookies.get(CLIENT_COOKIE) === SCA_COOKIE) {
        ScaBridge('logout', {}); // Logout from the SCA app
        return;
      }

      // Cookies.delete(SESSION_COOKIE);
      // redirect to login in case of public path
      if (
        isAuthenticatedRoute(error.config?.url ?? '') ||
        isAuthenticatedRoute(window.location.pathname)
      ) {
        // In development mode, fetch and set session Hash
        if (is.dev()) {
          const sessionHash = await fetchSession(
            {
              mobile_number: '9811898750',
              time_in_millis: Date.now(),
              user_agent: 'web',
            },
            {
              headers: {
                'x-api-key': 'abc12345-defg-6789-hijk-lmnopqrstuvwx',
              },
            },
          );
          if (sessionHash) {
            Cookies.set(SESSION_COOKIE, sessionHash);
          }
          window.location.assign(AMC_DEVICE_PAGE_URL);
          return;
        }

        const url = new URL(window.location.origin + LOGIN_URL);
        url.searchParams.append(LOGIN_REDIRECT_TO_QUERY, window.location.href);
        window.location.assign(url.toString());
        return;
      } else {
        location.reload();
      }
    } else {
      return Promise.reject(error);
    }
  },
);

export default axiosInstance;
